import { userStore } from '../state/store'
const jwtDecode = require('jwt-decode')

export const checkLoggedIn = () => {

  const token = sessionStorage.getItem('token')

  if (token) {
    const { user } = jwtDecode(token)
    userStore.set(user)
    return true
  }
  return false
}

export const checkSubscriptionStatus = () => {
  const token = sessionStorage.getItem('token')

  if (token) {
    const { user } = jwtDecode(token)
    return user.status === 'active' ||  user.status === 'trialing' ? true : false
  }
}
